export default "__VITE_ASSET__UzsaEifs__"